// extracted by mini-css-extract-plugin
module.exports = {"subheader":"OrderHistory_subheader__32pAh"};